import React, { useEffect, useState } from "react";
import styles from "./RandomImages.module.css";

const images = [
  "/images/modelos/Modelo1.png",
  "/images/modelos/Modelo2.png",
  "/images/modelos/Modelo3.png",
  "/images/modelos/Modelo4.png"
];

type ImageData = {
  src: string;
};

const RandomImage: React.FC = () => {
  const [imageData, setImageData] = useState<ImageData>({ src: images[0] });
  const [fadeClass, setFadeClass] = useState(styles.fadeIn);

  useEffect(() => {
    let index = Number(localStorage.getItem("imageIndex")) || 0;
    setImageData({ src: images[index] });

    const interval = setInterval(() => {
      // Inicia o fade out
      setFadeClass(styles.fadeOut);

      setTimeout(() => {
        // Atualiza a imagem depois do fade out
        index = (index + 1) % images.length;
        localStorage.setItem("imageIndex", index.toString());
        setImageData({ src: images[index] });

        // Inicia o fade in
        setFadeClass(styles.fadeIn);
      }, 500); // tempo do fadeOut
    }, 5000); // tempo de exibição da imagem

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.containerImages}>
      <img
        src={imageData.src}
        alt="Imagem de Pessoas com a finalidade de estarem estudando"
        className={`${styles.image} ${fadeClass}`}
        loading="lazy"
      />
    </div>
  );
};

export default RandomImage;
